/**
 * Created by Mateusz Lipowski on 28.11.2016.
 */


namespace Action.Other {
    export class RegionEdit extends Action.UserActionBase {
        protected formSender: Logic.FormSender = null;
        protected window: Entity.View.Window.Window = null;
        protected region: Entity.Map.Type.Region = null;
        protected form: HTMLFormElement = null;
        protected deleteButton: HTMLInputElement = null;

        public constructor(event: Action.UserActionEvent) {
            super(event);
        }

        public execute(): void {
            this.region = this.event.target as Entity.Map.Type.Region;
            this.window = App.getInstance().service.windowContainer.createWindow();
            this.window.show('region_edit');
            this.form = this.window.getForm();
            this.deleteButton = this.form['delete'] as HTMLInputElement;

            this.deleteButton.addEventListener('click', (e: MouseEvent): void => {
                if(confirm('Na pewno?')) {
                    this.sendDeleteRequest();
                }
            });

            this.initView();
            this.initFormSender();
        }

        protected initView(): void {
            this.form['id']['value'] = this.region.id;
            this.form['name']['value'] = this.region.name;
            this.form['prefix']['value'] = this.region.prefix;
        }

        protected initFormSender() {
            this.formSender = new Logic.FormSender(this.form, (action: string, fields: Object, response: any): void => {
                let alert: Entity.View.Alert;
                if(this.formSender.isError())
                    alert = new Entity.View.Alert(Entity.View.AlertType.ERROR, this.formSender.getMessage());
                else {
                    this.region.name = this.form['name']['value'];
                    this.region.prefix = this.form['prefix']['value'];
                    this.app.service.callbackContainer.invokeCallbacks('region', new Control.CallbackContainer.Event('update', this.region, {}));

                    for(let deviceNode of this.app.entityContainer.findNodesByRegionId(this.region.id)) {
                        if(!deviceNode)
                            continue;

                        deviceNode.update();
                    }

                    alert = new Entity.View.Alert(Entity.View.AlertType.SUCCESS, this.formSender.getMessage());
                    this.formSender.dispose();
                    this.window.dismiss();
                }
                alert.show();
            });
        }

        protected sendDeleteRequest(): void {
            let requestSender: Logic.RequestSender = new Logic.RequestSender();
            requestSender.sendRequest('DeleteRegion', {id: this.region.id}, (action: string, fields: Object, response: any): void => {
                let alert: Entity.View.Alert;
                if(requestSender.isError())
                    alert = new Entity.View.Alert(Entity.View.AlertType.ERROR, requestSender.getMessage());
                else {
                    this.app.entityContainer.deleteRegion(this.region.id);
                    this.app.service.callbackContainer.invokeCallbacks('region', new Control.CallbackContainer.Event('delete', this.region, {}));
                    this.app.service.callbackContainer.invokeCallbacks('region', new Control.CallbackContainer.Event('update', this.region, {}));
                    this.region = null;

                    alert = new Entity.View.Alert(Entity.View.AlertType.SUCCESS, requestSender.getMessage());
                    this.formSender.dispose();
                    this.window.dismiss();
                }
                alert.show();
            });
        }
    }
}
